// src/hooks/useFilterState.js
import { useState } from 'react';

/**
 * Управляет фильтрами с отложенным применением
 * Используется для текстовых полей: поиск, фильтры
 */
export const useFilterState = (initialFilters = {}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [tempValues, setTempValues] = useState({});

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setTempValues((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilter = (name) => {
    const value = tempValues[name] || '';
    setFilters((prev) => {
      if (prev[name] === value) return prev;
      return { ...prev, [name]: value };
    });
  };

  const handleTextBlur = (e) => {
    const { name } = e.target;
    applyFilter(name);
  };

  const handleTextKeyDown = (e) => {
    if (e.key === 'Enter') {
      const { name } = e.target;
      applyFilter(name);
      e.target.blur();
    }
  };

  const reset = () => {
    setFilters(initialFilters);
    setTempValues({});
  };

  return {
    filters,
    tempValues,
    handleTextChange,
    handleTextBlur,
    handleTextKeyDown,
    reset,
    setFilters, // для прямого обновления
  };
};

export default useFilterState;

